import { useTonAddress, useTonConnectUI } from '@tonconnect/ui-react';
import { shortenWalletAddress } from '@ethsign/utils-web';
import { Wallet03, X } from '@ethsign/icons';
import { Drawer, DrawerContent } from '@/components/Drawer.tsx';
import { TTGlowingLogo } from '@/components/Icons.tsx';
import { Button } from '@ethsign/ui';
import { useState } from 'react';
import waveImg from '@/assets/wave.png';
import { cn } from '@/utils/tailwind.ts';
import { GradientButton } from '@/components/GradientButton.tsx';
import { useContainerStore } from '@/hooks/useGlobalStore.ts';

const ConnectTonModal = ({ container }: { container?: HTMLElement | null }) => {
  const [open, setOpen] = useState(false);
  const [tonConnectUI] = useTonConnectUI();

  return (
    <>
      <span onClick={() => setOpen(true)} className={'text-foreground text-md font-medium cursor-pointer'}>
        Connect Wallet
      </span>
      <Drawer open={open} onOpenChange={setOpen} container={container}>
        <DrawerContent className={cn(container ? 'absolute' : '')}>
          <div
            className={'py-10 px-10 text-center relative'}
            style={{
              background: `url(${waveImg}) center center no-repeat`
            }}
          >
            <div className={'absolute right-4 top-4'} onClick={() => setOpen(false)}>
              <X className={'size-6'} color={'#FFF'} />
            </div>
            <div className={'flex justify-center'}>
              <TTGlowingLogo />
            </div>
            <h1 className={'mt-5 text-[25px] font-bold'}>Claim Airdrop Tokens</h1>
            <div className="text-secondary-foreground text-center text-xs font-medium">
              Your tokens are awaiting. Ready to claim?
            </div>
            <GradientButton
              className={'w-full mt-6'}
              size={'lg'}
              onClick={() => {
                setOpen(false);
                tonConnectUI.modal.open();
              }}
            >
              Connect Wallet
            </GradientButton>
            {/*<Button*/}
            {/*  variant={'outline'}*/}
            {/*  className={'w-full mt-6 border-primary-foreground text-primary-foreground gap-2'}*/}
            {/*  onClick={() => {*/}
            {/*    handleConnectWallet('okxTonWallet');*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <img src={okxIcon} className={'w-9 h-auto'} alt="" />*/}
            {/*  OKX Wallet*/}
            {/*  {GlobalConfig.OkxGasRefund && (*/}
            {/*    <div*/}
            {/*      className={'text-xs text-base bg-[#BBFF34] rounded-[50px] px-2 py-1'}*/}
            {/*      style={{*/}
            {/*        boxShadow: '0px 0.583px 1.165px 0px rgba(16, 24, 40, 0.05)'*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      🔥0 Gas Fee*/}
            {/*    </div>*/}
            {/*  )}*/}
            {/*</Button>*/}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

const DisconnectModal = ({ container }: { container?: HTMLElement | null }) => {
  const [tonConnectUI] = useTonConnectUI();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
        }}
        className={'border-none flex items-center gap-2 py-1 px-2 text-xs font-medium text-secondary-foreground'}
      >
        Log out
      </button>
      <Drawer open={open} onOpenChange={setOpen} container={container}>
        <DrawerContent className={cn(container ? 'absolute' : '')}>
          <div className={'py-6 px-[65px] pb-[64px] relative'}>
            <div className={'absolute right-4 top-4'} onClick={() => setOpen(false)}>
              <X className={'size-6'} color={'#FFF'} />
            </div>
            <div className={'flex justify-center py-6'}>
              <Wallet03 color={'#FFF'} className={'size-16'} />
            </div>
            <div>
              <div className={'text-center text-xl text-primary-foreground w-full font-bold'}>
                Are you sure to disconnect wallet?
              </div>
              <div className={'mt-4 text-center'}>
                <Button
                  variant={'destructive'}
                  className={'w-full border border-red-600 bg-transparent text-red-600'}
                  onClick={() => {
                    tonConnectUI.disconnect();
                  }}
                >
                  Disconnect
                </Button>
              </div>
            </div>
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export const Header = ({ className }: { className?: string }) => {
  const address = useTonAddress();
  const { container } = useContainerStore();

  return (
    <div className={cn('flex justify-between items-center bg-card rounded-[16px] p-4', className)}>
      <div className={'text-md font-medium text-white flex gap-2 items-center'}>
        <Wallet03 color={'#C3C3C5'} />
        {address ? <div className="size-2 bg-slime-500 rounded-full"></div> : null}
        {address ? <span>{shortenWalletAddress(address, 'shorter')}</span> : <ConnectTonModal container={container} />}
      </div>

      <div>{address ? <DisconnectModal container={container} /> : null}</div>
    </div>
  );
};
